module.exports = __webpack_public_path__ + "img/20240110161029253sns.5b16ba62.jpg";